import { batchConstants } from "./constants/batchConstants";


export const getBatch = (data:any) => ({
  type: batchConstants.getBatchRequest,
  payload : data
}); 

const createBatch = (data: any) => ({
  type: batchConstants.batchCreateRequest,
  payload: data,
});

const getBatchParams = (data: any) => ({
  type: batchConstants.getBatchParamsRequest,
  payload: data,
});

const deleteBatch = (data: any) => ({
  type: batchConstants.batchDeleteRequest,
  payload: data,
});

const toggleBatch = (data: any) => ({
  type: batchConstants.batchToggleRequest,
  payload: data,
});

const getAvailableUsers = (data: any) => ({
  type: batchConstants.getAvailableUsersRequest,
  payload: data,
});

const viewBatch = (data: any) => ({
  type: batchConstants.batchViewRequest,
  payload: data,
});

const getAvailableStudentsRequest = (data: any) => ({
  type: batchConstants.getAvailableStudentsRequest,
  payload: data,
});

const markAttendance = (data: any) => ({
  type: batchConstants.attendanceMarkedRequest,
  payload: data,
});

const getBatchHistory = (data: any) => ({
  type: batchConstants.getBatchHistoryRequest,
  payload: data,
});

const getOverallStudentAnalytics = (data: any) => ({
  type: batchConstants.getOverallStudentAnalyticsRequest,
  payload: data,
});

const getSessionAnalytics = (data: any) => ({
  type: batchConstants.getSessionAnalyticsRequest,
  payload: data,
});

const getAvailableStudentsForBatch = (data: any) => ({
  type: batchConstants.getAvailableStudentsForBatchRequest,
  payload: data,
});

const getCalendarDetails = (data: any) => ({
  type: batchConstants.getCalendarDetailsRequest,
  payload: data,
});


export const batchActions = {
  getBatch,
  createBatch,
  getBatchParams,
  toggleBatch,
  deleteBatch,
  getAvailableStudentsRequest,
  getAvailableUsers,
  viewBatch,
  markAttendance,
  getBatchHistory,
  getOverallStudentAnalytics,
  getSessionAnalytics,
  getAvailableStudentsForBatch,
  getCalendarDetails
};
